const reviewList = {
    list: () => 'filterKeywords',
    create:()=>'create/reviewTag',
    listDetail:(id)=>`getAllReviewTags`,
    update: (id) => `update/reviewTag/${id}`,
    getById: (id) => `getReviewTagById/${id}`,
    delete: (id) => `delete/reviewTag/${id}`,
}
export default reviewList
